<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    activeIconDescription: {
      type: Object
    }
  },
  data () {
    return {
      activeName: 'filled',
      // selectedCategory: null,
      activeIconInfo: null,
      activeCategory: null
    }
  },
  computed: {
    ...mapGetters(['resource', 'domainSettings', 'subscription']),
    ...mapGetters('iconGallery', [
      'visible',
      'rendered',
      'IconInfo',
      'objFolderIcons'
    ]),
    IconCategories () {
      return this.IconInfo.map(category => {
        return {
          id: category.Id,
          name: category.IconCategoryName,
          value: category.IconFolderName
        }
      })
    },
    selectedCategory: {
      get () {
        if (!this.activeCategory && this.IconCategories && this.IconCategories.length > 0) {
          this.activeCategory = this.IconCategories[0]
        }
        return this.activeCategory
      },
      set (value) {
        this.activeCategory = value
      }
    },
    selectedCategoryFilledIcons () {
      return this.getSelectedCategoryIcons('filled')
    },
    selectedCategoryOutlinedIcons () {
      return this.getSelectedCategoryIcons('outlined')
    },
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.activeName = 'filled'
          this.activeCategory = null
          this.activeIconInfo = null
          this.hideGallery()
        }
        // this.$emit('update:visible', value)
      }
    },
    defaultActiveMenu () {
      const categoryIndex = this.selectedCategoryIndex()
      if (categoryIndex === -1) {
        return '1'
      }
      return (categoryIndex + 1).toString()
    }
  },
  // async created () {
  //   await this.$store.dispatch('initIconGallery')
  //   if (this.IconCategories && this.IconCategories.length > 0) {
  //     this.setSelectedCategory(this.IconCategories[0])
  //   }
  // },
  methods: {
    ...mapActions('iconGallery', [
      'initIconGallery',
      'setDialogResult',
      'activityLog',
      'hideGallery'
    ]),
    selectedCategoryIndex () {
      return this.IconCategories.findIndex(category => {
        return this.selectedCategory && category.value === this.selectedCategory.value
      })
    },
    setActiveIconAndCategory ({ name, type, categoryName }) {
      // this.activeIconInfo = {
      //   name,
      //   type,
      //   category: {
      //     value: categoryName
      //   }
      // }
      // this.selectedCategory = {
      //   value: categoryName
      // }
      // this.activeName = type
      // this.$nextTick(() => {
      //   const iconBox = document.querySelector('li.icon-box.active')
      //   const category = document.querySelector('li.el-menu-item.is-active')
      //   category && category.scrollIntoView()
      //   iconBox && iconBox.scrollIntoView()
      // })
    },
    parseActiveIconDescriptionProp () {
      if (this.activeIconDescription) {
        const { name, type, categoryName } = this.activeIconDescription
        return {
          name,
          type,
          category: {
            value: categoryName
          }
        }
      }
      return null
    },
    handleCategorySelect (id) {
      this.activeIconInfo = null
      const category = this.IconCategories.find(category => category.id === Number.parseInt(id, 10))
      this.selectedCategory = category
    },
    getSelectedCategoryIcons (type) {
      const icons = this.objFolderIcons.find(icons => {
        if (this.selectedCategory) {
          return icons.CategoryName === this.selectedCategory.value && icons.IconType === type
        }
      })
      if (icons) {
        return icons.IconInfoobj
      }
      return []
    },
    filledIconUrl (icon) {
      return `${this.domainSettings.AppsFTPURL}.system/app_icons/filled/${this.selectedCategory.value}/${icon}`
    },
    outlinedIconUrl (icon) {
      return `${this.domainSettings.AppsFTPURL}.system/app_icons/outlined/${this.selectedCategory.value}/${icon}`
    },
    setActiveIcon (name, type) {
      this.activeIconInfo = {
        name,
        type,
        category: this.selectedCategory
      }
    },
    selectedIcon (icon, type) {
      if (this.activeIconInfo && this.activeIconInfo.name === icon.FileName && this.activeIconInfo.type === type) {
        return true
      } else {
        return false
      }
    },
    saveIcon () {
      if (this.activeIconInfo) {
        // this.$emit('selected-icon', this.activeIconInfo)
        this.setDialogResult(this.activeIconInfo)
      }
      // this.dialogVisible = false
    },
    handleClose () {
      this.dialogVisible = false
      this.$emit('closed', this.activeIconInfo)
    }
  }
}
</script>

<template>
  <div v-if="rendered">
    <el-dialog
      :title="resource.icongallerytitle"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      size="small"
      custom-class="fullimagedialog menuiconsdialog"
      append-to-body>
      <div class="menuiconscontainer height-100">
        <el-row type="flex" class="height-100">
          <el-col :span="8">
            <div class="menuicons height-100" v-if="IconCategories.length > 0">
              <el-menu
                :default-active="defaultActiveMenu"
                class="el-menu-vertical-demo"
                @select="handleCategorySelect">
                <el-menu-item
                  v-for="category in IconCategories"
                  :index="category.id + ''"
                  :key="category.id">
                  {{ category.name }}
                </el-menu-item>
              </el-menu>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="menuicontabscontainer">
              <el-tabs v-model="activeName" class='innercustomtabs'>
                <el-tab-pane :label="resource.filledicon" name="filled">
                  <div class="menuiconlistwrapper">
                    <ul class="menuiconslist">
                      <li v-for="(icon, index) in selectedCategoryFilledIcons"
                        :key="index"
                        :class="{'active' : selectedIcon(icon, 'filled')}"
                        @click="setActiveIcon(icon.FileName, 'filled')"
                        class="icon-box">
                        <a href="javascript:void(0);">
                          <img :src="filledIconUrl(icon.FileName)" :alt="icon.FileName" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="resource.outlinedicon" name="outlined">
                  <ul class="menuiconslist">
                    <li v-for="(icon, index) in selectedCategoryOutlinedIcons"
                      :key="index"
                      :class="{'active' : selectedIcon(icon, 'outlined')}"
                      @click="setActiveIcon(icon.FileName, 'outlined')"
                      class="icon-box">
                      <a href="javascript:void(0);">
                        <img :src="outlinedIconUrl(icon.FileName)" :alt="icon.FileName" />
                      </a>
                    </li>
                  </ul>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{resource.cancelupload}}</el-button>
        <el-button
        :disabled="activeIconInfo === null"
        type="primary"
        @click="saveIcon()">{{resource.saveicon}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
  .menuiconsdialog {
      width: 900px;
      height: 600px;
      padding: 0 20px;
  }
  .menuiconsdialog .el-dialog__body {
    padding: 20px 20px;
    height: 447px;
  }
  .menuiconsdialog .el-dialog__title {
    font-size: 24px;
    font-weight: normal;
  }
  .menuiconsdialog .el-tabs__content {
      height: 330px;
  }
  .menuiconsdialog .el-tab-pane {
      height: 325px;
      border: 1px solid #ccc;
      padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Shared/IconGallery.vue